export interface ILocalStorageSettings {
  preservedKeys?: string[]
}

class LocalStorageController {
  private localStorage = window.localStorage
  private preservedKeys = new Set<string>()

  public configure(settings?: ILocalStorageSettings) {
    this.preservedKeys = new Set(settings?.preservedKeys)
  }

  public checkAvailable = (): boolean => {
    if (typeof localStorage !== 'undefined') {
      const text = 'test'
      try {
        localStorage.setItem(text, text)
        if (localStorage.getItem(text) === text) {
          localStorage.removeItem(text)
          return true
        }
        return false
      } catch (e) {
        return false
      }
    }
    return false
  }

  public setItem(key: string, value: string) {
    return this.localStorage.setItem(key, value)
  }

  public getItem(key: string) {
    return this.localStorage.getItem(key)
  }

  public removeItem(key: string) {
    return this.localStorage.removeItem(key)
  }

  public clear() {
    if (this.preservedKeys.size) {
      Object.keys(this.localStorage).forEach((key) => {
        if (!this.preservedKeys.has(key)) {
          this.localStorage.removeItem(key)
        }
      })
      return
    }

    return this.localStorage.clear()
  }
}

export default new LocalStorageController()
